import React from 'react';
import '../styles/Cursos.css'

const Cursos = () => {
  return (
    <div>
      <div class="wrap">
       
        <h1>Cursos para padres</h1>

        <br/>
        <div class="cursos-card">
            <div class="cursos-content">
            <h3>Globoflexia</h3>
            <div class="divider"></div>
            <h3>El payaso Tim</h3>
            <div class="divider"></div>
            <h3>Lunes 21, a las 16:00</h3>
            <div class="divider"></div>
            <p>El payaso Tim cuenta con 20 años haciendo globoflexia, y nos enseñará a hacer formas básicas para entretener a los mas peques.</p>
            <p>Para apuntarse, llamar al telefono que aparece en la pestaña de contacto, o mandar un mail.</p>
          </div>
        </div>

        <br/>

        <div class="cursos-card">
          <div class="cursos-content">
            <h3>Los beneficios de la siesta</h3>
            <div class="divider"></div>
            <h3>Psicologa, Saray Ares</h3>
            <div class="divider"></div>
            <h3>Miercoles 23, a las 17:00</h3>
            <div class="divider"></div>
            <p>La psicologa nos mostrará la importancia que tiene la siesta para el correcto desarrollo mental de los peques.</p>
            <p>Para apuntarse, llamar al telefono que aparece en la pestaña de contacto, o mandar un mail.</p>
          </div>
        </div>

        <br/>

        <div class="cursos-card">
          <div class="cursos-content">
            <h3>Hábitos de un buen padre</h3>
            <div class="divider"></div>
            <h3>Especialista en paternidad, Pablo Sande</h3>
            <div class="divider"></div>
            <h3>Viernes 25, a las 17:00</h3>
            <div class="divider"></div>
            <p>Todos los padres primerizos tienen duda, por lo cual, con el especialista en paternidad, podremos abordar todas las dudas que nos puedan surgir</p>
            <p>Para apuntarse, llamar al telefono que aparece en la pestaña de contacto, o mandar un mail.</p>
          </div>
        </div>

        <br/>
      </div>
    </div>
  )
}

export default Cursos;